import * as DigitalAssetApi from 'api/DigitalAssetApi';
import {updatePropertyImageUri, updateSelectedPropertyImage, updateTargetPhotoList} from 'ducks/propertyDetail';
import * as ImageResizer from 'lib/ImageResizer';

const convertToReadUrl = function (uploadUrl) {
  return uploadUrl.split('?')[0];
};

export function uploadImageToTargetPropertyGalleryList(file, galleryIndex) {
  return async (dispatch, getState) => {
    const {propertyDetail} = getState();
    const readUrl = await uploadAsset(file, propertyDetail);
    dispatch(updateTargetPhotoList(galleryIndex, readUrl, true));
  };
}

export function uploadImageToSummaryGalleryList(file, galleryIndex) {
  return async (dispatch, getState) => {
    const {propertyDetail} = getState();
    const readUrl = await uploadAsset(file, propertyDetail);
    dispatch(updateSelectedPropertyImage(galleryIndex, readUrl, true));
  };
}

export function uploadImageToPropertyImagesList(file) {
  return async (dispatch, getState) => {
    const {propertyDetail} = getState();
    const readUrl = await uploadAsset(file, propertyDetail);
    dispatch(updatePropertyImageUri(readUrl));
  };
}

const uploadAsset = async (file, propertyDetail) => {
    const resizedFile = await ImageResizer.resize(file);
    const {data: {url}} = await DigitalAssetApi.uploadDigitalAsset({
      source: 'upload-property-image',
      propertyId: propertyDetail.propertyId,
      file: resizedFile
    });
    return convertToReadUrl(url);
};